<template>
    <div class="product-aside-prices">
      <span v-if="hasDiscount" class="product-aside-price product-aside-price--discounted">
        <span class="product-aside-price-was">Was {{ price.compare_at_price_formatted_plus_vat }}</span>
        <span class="product-aside-price-now">Now {{ price.price_formatted_plus_vat }}</span>
      </span>
      <span v-else-if="product.market_prices && product.market_prices.length" :class="priceClass">
        {{ price.price_formatted_plus_vat }}
      </span>
      <span class="product-aside-price-exvat">tax & duties included</span>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    product: Object,
    priceExVatClass: String,
    priceClass: String
  },
  computed: {
    ...mapGetters(['currentMarket']),
    hasDiscount() {
      return Boolean(
        this.price &&
        this.price.is_discounted &&
        this.price.compare_at_price_formatted_plus_vat &&
        this.price.price_formatted_plus_vat
      );
    },
    price() {
      if (
        this.product &&
        Array.isArray(this.product.market_prices) &&
        this.product.market_prices.length
      ) {
        return this.product.market_prices.find(
          price => price.country_code === this.currentMarket
        ) || {};
      }
      return {};
    }
  }
};
</script>
